<template>
    <table class="table table-light rounded module-order-table">
        <thead class="thead-dark">
            <tr>
                <th>{{ $t('Position') }}</th>
                <th>{{ $t('Module type') }}</th>
                <th>{{ $t('Article') }}</th>
                <th>{{ $t('Article no.') }}</th>
                <th>{{ $t('Mounting rail') }}</th>
                <th>{{ $t('PIN L') }}</th>
                <th>{{ $t('PIN N') }}</th>
                <th>{{ $t('PIN NOT') }}</th>
            </tr>
        </thead>
        <tbody>
            <tr v-for="module in mountingRailArrangement" :class="[module.type, {'emergency_light': module.emergency_light}]">
                <td>{{ module.module_order_slot }}</td>
                <td>{{ $t(module.module_type_title) }}</td>
                <td>{{ $t(module.title) }}<span v-if="module.submodules && module.submodules.length > 0" v-html="module.submodules_string"></span></td>
                <td>{{ module.sku }}</td>
                <td><span v-if="module.mounting_rail_title">{{ module.mounting_rail_order_index }}. {{ $t(module.mounting_rail_title) }} ({{ $t('Article no.') }}: {{ module.mounting_rail_sku }})</span></td>
                <td>{{ module.pin_l && module.type === 'led_module' ? module.pin_l : '' }}</td>
                <td>{{ module.pin_n && module.type === 'led_module' ? module.pin_n : '' }}</td>
                <td>{{ module.pin_not && module.type === 'led_module' && module.emergency_light ? module.pin_not : '' }}</td>
            </tr>
        </tbody>
    </table>
</template>

<script>

export default {

    props: ['product_configurator_id', 'mountingRailArrangementData', 'allApiCallsLoaded', 'emergency_light'],

    data() {
        return {
            mountingRailArrangement: [],
            // States
            mountingRailDataSet: false,
        };
    },

    mounted() {
        if (this.allApiCallsLoaded && !this.mountingRailDataSet) {
            this.setMountingRailArrangementData();
        }
    },

    methods: {

        setMountingRailArrangementData() {

            let mountingRailOrderIndex = 0;
            let moduleOrderSlot = 0;

            this.mountingRailArrangement = this.mountingRailArrangementData.flatMap( el => {
                if (!this.itemIsMountingRail(el)) {
                    let module = {};
                    moduleOrderSlot++;

                    module.module_order_slot    = moduleOrderSlot;
                    module.module_type_title    = this.getModuleTypeTitle(el.product_type);
                    module.type                 = el.product_type;
                    module.title                = el.title;
                    module.sku                  = el.sku;

                    return module;
                } else {
                    mountingRailOrderIndex++;
                    return el.modules.map( module => {
                        moduleOrderSlot++;

                        module.module_order_slot            = moduleOrderSlot;
                        module.module_type_title            = this.getModuleTypeTitle(module.type);
                        module.mounting_rail_order_index    = mountingRailOrderIndex;
                        module.mounting_rail_title          = el.title;
                        module.mounting_rail_sku            = el.sku;
                        module.mounting_rail_product_id     = el.product_id;
                        module.mounting_rail_length         = el.length;
                        module.title                        = module.emergency_light && this.emergency_light ? this.$t(module.title) + ' (' +  this.$t(this.emergency_light.title) + ': ' + this.emergency_light.sku + ')' : module.title;

                        module.submodules_string = module.submodules
                        ? '<ul>' +
                            module.submodules?.map((product, index) => {
                                let title = product?.product_title ? this.$t(product.product_title) + ' (' + product.sku + ')' : ' – ';
                                return '<li>' + this.$t('Position') + ' ' + (index + 1) + ': ' + title + '</li>';
                            }).join('')
                            + '</ul>'
                        : false;

                        return module;
                    });
                }

            });

            this.mountingRailDataSet = true;

        },

        itemIsMountingRail(item) {
            return item.product_type === 'mountingrail' || item.product_type === 'mountingrail_with_connectors';
        },

        getModuleTypeTitle(type) {

            if (type === 'led_module') {
                return 'LED module';
            }

            if (type === 'blind_module') {
                return 'Blind module';
            }

            if (type === 'luminaire_control') {
                return 'Control';
            }

            if (type === 'universal_connector') {
                return 'Universal connector';
            }

            if (type === 'emergency_light') {
                return 'Emergency light';
            }
        },

    },

    watch: {
        allApiCallsLoaded: {
            handler: function(loaded, oldVal) {
                if (loaded && !this.mountingRailDataSet) {
                    this.setMountingRailArrangementData();
                }
            },
            deep: true
        },

    },

};
</script>
